import { apiClient } from 'modules/api-client';
import { useCurrentUser } from 'modules/auth/AuthContext';
import type React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

type FeatureFlagsType = Record<string, boolean | string | number>;

type FeatureFlagsState = {
  flags: FeatureFlagsType;
  loaded: boolean;
};

const initialState: FeatureFlagsState = { flags: {}, loaded: false };

export const FeatureFlagsContext =
  createContext<FeatureFlagsState>(initialState);

export function FeatureFlagsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, setState] = useState(initialState);
  const { user } = useCurrentUser();
  const userToken = user.token || '';

  useEffect(() => {
    if (!userToken) {
      if (state.loaded) {
        setState(initialState);
      }
      return;
    }
    if (state.loaded) return;

    apiClient.flag.getAllFlags(userToken).then((payload) => {
      setState({ flags: payload, loaded: true });
    });
  }, [userToken, state.loaded]);

  return (
    <FeatureFlagsContext.Provider value={state}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
